import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style.css';

const Header = () => (
	<header class={style.header}>
		<div class={style.container}>
			<Link href="/" class={style.logo}>Sashruthi</Link>
		<nav class={style.nav}>
			<Link activeClassName={style.active} href="/">Home</Link>
			<Link activeClassName={style.active} href="/projects">Projects</Link>
			<Link activeClassName={style.active} href="/resume">Resume</Link>
			<Link activeClassName={style.active} href="/contact">Contact</Link>
		</nav>
		</div>
	</header>
);

export default Header;
